import { createReducer, on } from "@ngrx/store";
import { addTipoDocumentos, addTipoDocumentosError, clearTipoDocumentos, deleteTipoDocumento, updateTipoDocumento } from "../actions/tipoDocumento.actions";
import { initialTipoDocumentosState } from "../../core/interfaces/models/tipoDocumento.interface";


export const documentoReducer = createReducer(
  initialTipoDocumentosState,
  on(addTipoDocumentos, (_, { tipoDocumentosState }) => (
    tipoDocumentosState
  )),
  on(addTipoDocumentosError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updateTipoDocumento, (state, { tipoDocumento }) => ({
    ...state,
    tipoDocumentos: state.tipoDocumentos.map(u =>
      u.id === tipoDocumento.id ? tipoDocumento : u
    )
  })),
  on(deleteTipoDocumento, (state, { id }) => ({
    ...state,
    tipoDocumentos: state.tipoDocumentos.filter(u => u.id !== id)
  })),

  on(clearTipoDocumentos, () => initialTipoDocumentosState)
);